import { SignTransactionNotSupportedBySmartAccountError, toSigner } from "@zerodev/sdk";
import { getUserOperationHash } from "viem/account-abstraction";
import { toAccount } from "viem/accounts";
import { signMessage } from "viem/actions";
import { getChainId } from "viem/actions";
import { MULTI_CHAIN_ECDSA_VALIDATOR_ADDRESS } from "./constants.js";
import { ecdsaGetMultiUserOpDummySignature } from "./utils/ecdsaGetMultiUserOpDummySignature.js";
export async function toMultiChainECDSAValidator(client, { signer, entryPoint, kernelVersion: _, validatorAddress: validatorAddress_, multiChainIds }) {
    const validatorAddress = validatorAddress_ ?? MULTI_CHAIN_ECDSA_VALIDATOR_ADDRESS;
    // Get the private key related account
    const viemSigner = await toSigner({ signer });
    // Fetch chain id
    const chainId = await getChainId(client);
    // Build the EOA Signer
    const account = toAccount({
        address: viemSigner.address,
        async signMessage({ message }) {
            return signMessage(client, { account: viemSigner, message });
        },
        async signTransaction(_, __) {
            throw new SignTransactionNotSupportedBySmartAccountError();
        },
        async signTypedData(typedData) {
            return viemSigner.signTypedData(typedData);
        }
    });
    return {
        ...account,
        supportedKernelVersions: ">=0.3.0",
        validatorType: "SECONDARY",
        address: validatorAddress,
        source: "MultiChainECDSAValidator",
        getIdentifier() {
            return validatorAddress ?? MULTI_CHAIN_ECDSA_VALIDATOR_ADDRESS;
        },
        async getEnableData() {
            return viemSigner.address;
        },
        async getNonceKey(_accountAddress, customNonceKey) {
            if (customNonceKey) {
                return customNonceKey;
            }
            return 0n;
        },
        async signUserOperation(userOperation) {
            const hash = getUserOperationHash({
                userOperation: {
                    ...userOperation,
                    signature: "0x"
                },
                entryPointAddress: entryPoint.address,
                entryPointVersion: entryPoint.version,
                chainId: chainId
            });
            const signature = await signMessage(client, {
                account: viemSigner,
                message: { raw: hash }
            });
            return signature;
        },
        async getStubSignature(userOperation) {
            if (!multiChainIds)
                return "0xfffffffffffffffffffffffffffffff0000000000000000000000000000000007aaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaaa1c";
            return ecdsaGetMultiUserOpDummySignature({
                ...userOperation,
                callGasLimit: 0n,
                preVerificationGas: 0n,
                verificationGasLimit: 0n
            }, multiChainIds.length, entryPoint, chainId);
        },
        async isEnabled(_kernelAccountAddress, _selector) {
            return false;
        }
    };
}
//# sourceMappingURL=toMultiChainECDSAValidator.js.map